export const contacts = {
  'CONTACTS': 'CONTACTS',
  'Get in touch': 'Get in touch',
  '45 Rockefeller Plaza 1': '45 Rockefeller Plaza 1',
  'Suite 2508': 'Suite 2508',
  'New York, New York 10111': 'New York, New York 10111',
}

export default contacts
